export default "__VITE_ASSET__ivF_g1hz__"